import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { forwardRef } from 'react';

export const HierarchicalIcon = forwardRef<SVGSVGElement, SvgWrapperProps>(
  (props, ref) => (
    <SvgWrapper fill='none' ref={ref} viewBox='0 0 16 16' {...props}>
      <circle cx='1.5' cy='7.5' r='1.5' fill='currentColor' />
      <path
        d='M8.5 7.5V1.5H14.5M8.5 7.5H1.5M8.5 7.5V14.5H14.5'
        stroke='currentColor'
      />
      <path d='M14.5 10.5L8.5 7.5L14.5 5.5' stroke='currentColor' />
      <circle cx='8.5' cy='1.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='1.5' r='1.5' fill='currentColor' />
      <circle cx='8.5' cy='7.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='10.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='5.5' r='1.5' fill='currentColor' />
      <circle cx='8.5' cy='14.5' r='1.5' fill='currentColor' />
      <circle cx='14.5' cy='14.5' r='1.5' fill='currentColor' />
    </SvgWrapper>
  ),
);

HierarchicalIcon.displayName = 'HierarchicalIcon';
